import React from "react";
import { Link, useParams } from "react-router-dom";

const AdminClozes: React.FC = () => {
  const { collectionId } = useParams();
  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <h1 className="text-2xl font-semibold text-zinc-900 dark:text-zinc-100 mb-6">
        Admin – Clozes {collectionId ? `(Collection ${collectionId})` : ""}
      </h1>
      <Link
        to="/admin/collections"
        className="text-cyan-600 dark:text-cyan-400 hover:underline"
      >
        ← Back to Collections
      </Link>
    </div>
  );
};

export default AdminClozes;
